var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.getColor()}},[_vm._v(" "+_vm._s(_vm.course.course.name)+" - "+_vm._s(_vm.getStatusText())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }